const protocols = ["http://", "https://", "mailto:"];

export const getCleanUrl = (url: string): string => {
  let lastProtocolIndex = -1;
  let urlToCheck = url;
  let currentIndex = 0;

  while (true) {
    let foundProtocol = false;

    for (const protocol of protocols) {
      if (urlToCheck.startsWith(protocol)) {
        lastProtocolIndex = currentIndex;
        currentIndex += protocol.length;
        urlToCheck = urlToCheck.substring(protocol.length);
        foundProtocol = true;
        break;
      }
    }

    if (!foundProtocol) break;
  }

  return lastProtocolIndex !== -1 ? url.substring(lastProtocolIndex) : url;
};
